import React from 'react';
import PropTypes from 'prop-types';

const ModalButtons = ({ buttons, ...props }) => {
  return (
    <div {...props}>
      {buttons.map((btn, index) => (
        <button
          key={index}
          className={btn.className}
          style={btn.style}
          type={btn.type ?? 'button'}
          onClick={btn.action}
          data-test-id={btn.title}
        >
          {btn.title}
        </button>
      ))}
    </div>
  );
};

ModalButtons.proptypes = {
  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      className: PropTypes.string,
      style: PropTypes.object,
      action: PropTypes.func,
    }),
  ).isRequired,
};

export default ModalButtons;
